<template>
  <transition name="fade" mode="out-in">
    <b-skeleton
      height="200px"
      :animated="true"
      v-if="isLoadingFolder"
    ></b-skeleton>
    <div class="card" v-else>
      <header class="card-header">
        <p class="card-header-title">Documentos Eliminados</p>
      </header>
      <router-link
        :to="{
          name: `trash${profile.charAt(0).toUpperCase() + profile.slice(1)}`,
          params: { id: $route.params.id },
        }"
      >
        <div class="card-content">
          <div class="content">
            <div class="columns">
              <div class="column">
                <figure class="image is-64x64">
                  <img src="/trash-icon.png" alt="Image" />
                </figure>
              </div>
              <div class="column">
                <b-icon pack="fas" icon="file-alt" size="is-small"> </b-icon>
                {{ cant }}
              </div>
            </div>
          </div>
        </div>
        <footer class="card-footer">
          <a class="card-footer-item"> Ver Papelera</a>
        </footer>
      </router-link>
    </div>
  </transition>
</template>
<script>
import { DocumentService } from "../../../services/models/document";

export default {
  data() {
    return {
      isLoadingFolder: false,
      cant: 0,
      profile: window.localStorage.getItem("perfil")
    };
  },
  mounted(){
    this.chargeData();
  },
  methods: {    
    async chargeData() {
      this.isLoadingFolder = true;
      const {data:cantDelete} = await DocumentService.getCountDeletedByCellarId(
        this.$route.params.id
      );
      this.cant=cantDelete;
      this.isLoadingFolder = false;
    },
  },
};
</script>